import { Container } from './ScratchCard.styles'
import { IScratchCardProps } from './ScratchCard.types'

export const ScratchCard = ({ children, scale, ...props }: IScratchCardProps) => (
  <Container $scale={scale} {...props}>
    {children}
  </Container>
)
